import request from "@/router/axios"
export const syncDoctor = () => {
    return request({
        url: `/api/basis/task/syncDoctor`,
        method: 'post',
        timeout: 300000
    })
}
